import { supabase } from "@shared/integrations/supabase/client";

/**
 * Check if the current authenticated user has the admin role
 */
export const isUserAdmin = async (): Promise<boolean> => {
	try {
		const { data, error } = await supabase
			.from("user_roles")
			.select("role")
			.eq("role", "admin")
			.maybeSingle();

		if (error) {
			console.error("Error checking admin status:", error);
			return false;
		}

		return Boolean(data);
	} catch (error) {
		console.error("Error checking admin status:", error);
		return false;
	}
};

/**
 * Check if a specific user ID has the admin role
 */
export const isUserIdAdmin = async (userId: string): Promise<boolean> => {
	try {
		const { data, error } = await supabase
			.from("user_roles")
			.select("role")
			.eq("user_id", userId)
			.eq("role", "admin")
			.maybeSingle();

		if (error) {
			console.error("Error checking admin status:", error);
			return false;
		}

		return Boolean(data);
	} catch (error) {
		console.error("Error checking admin status:", error);
		return false;
	}
};
